import { config } from '../config';

import { datadogLogs } from './datadog';

type LogLevel = 'error' | 'warn' | 'log' | 'info' | 'debug';

type LogMethod = (message: string, extras?: object) => void;

export type Logger = Record<LogLevel, LogMethod>;

const LOG_LEVELS: LogLevel[] = ['error', 'warn', 'log', 'info', 'debug'];

export const getLogger = (loggerName: string): Logger => {
  const logger = datadogLogs.createLogger(loggerName, {
    level: config.datadog.logs.level,
  });

  return Object.fromEntries(
    LOG_LEVELS.map((level) => [
      level,
      (message: string, extras?: object) => {
        console[level](`[${loggerName}]:`, message, extras);
        logger[level](message, extras);
      },
    ])
  ) as Logger;
};
